// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TypeOfTicketField__wrapper___38mwz","content":"TypeOfTicketField__content___G6TGk"};